import React, { Component } from 'react';
import { Context } from 'context';

import styles from 'editor/workspace/window/viewer/toolbar/toolBar.module.scss';

class Smoothing extends Component {
    static contextType = Context;

    render() {
        const {topLeft, bottomRight} = this.props.selection;
        const disabled = !((topLeft.i - bottomRight.i) || (topLeft.j - bottomRight.j));

        return (
            <img
                src={require(`images/icons/smoothing${this.context.lightTheme ? "-light" : "-dark"}.svg`)}
                className={`${styles.smoothing} bgTertiary ${disabled ? 'disabled' : null}`}
                alt="Smooth"
                onClick={disabled ? null : this.props.smooth}
                data-hint={this.context.text.hints.smooth}
            />
        )
    }
}

export default Smoothing;
